<template>
  <div :id="name" class="body-movin-container" />
</template>

<script>
import * as bodymovin from "lottie-web";

export default {
  name: "BodyMovin",
  props: {
    src: {
      tpye: String,
      required: true,
    },
    name: {
      tpye: String,
      required: true,
    },
    acitve: {
      tpye: Boolean,
      default: true,
    },
    loop_flag: {
      tpye: Boolean,
      default: true,
    },
    autoplay_flag: {
      tpye: Boolean,
      default: true,
    },
    subtitle_flag: {
      tpye: Boolean,
      default: false,
    },
  },
  watch: {
    acitve: {
      handler(value) {
        // if(!value && this.name=='voicebluranimate') this.bm.pause();  
        if(!value && this.name=='voicesubtitle'){
          //console.log(1)
          this.bm.pause();  
        }
        if(value && this.name=='voicesubtitle') {
          //console.log(2)
          this.bm.play();  
        }
      }
    },
    subtitle_flag: {
      handler(value) {  
        if(value && this.name=='voicesubtitle'){
          //console.log(3)
          this.bm.stop();
          this.bm.play(); 
        }
      }
    }
  },
  mounted() {
    this.bm = bodymovin.loadAnimation({
      container: document.getElementById(`${this.name}`),
      renderer: "svg",
      loop: this.loop_flag,
      autoplay: this.autoplay_flag,
      path: this.src,
    });
    this.bm.onComplete = () => {
      this.$emit('childYalp',false);
    }
  },
};

</script>

<style lang="scss" scoped>
  .body-movin-container {
    width: 100%;
    height: 100%;
  }
</style>